import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Injector,
  OnInit,
  Signal,
  computed,
  effect,
  inject,
  input,
  runInInjectionContext,
} from '@angular/core'

import { FlxStyleModule, FlxThemeModule, FlxWrapperStyleDirective } from '@flowx/angular-theme'
import { FlxMarkdownComponent } from '@flowx/angular-ui-toolkit'
import { MarkdownTemplateConfig } from '@flowx/core-sdk'

import { FlxLocalizePipe } from '../../pipes/flx-localize.pipe'
import { getBoolExpressionSignal, getDynamicPropSignal } from '../helpers'

@Component({
  selector: 'flx-markdown-wrapper',
  hostDirectives: [
    { directive: FlxWrapperStyleDirective, inputs: ['flxWrapperStyle: templateConfig'] },
  ],
  imports: [FlxMarkdownComponent, FlxLocalizePipe, FlxThemeModule, FlxStyleModule],
  templateUrl: './markdown-wrapper.component.html',
  styleUrl: './markdown-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlxMarkdownWrapperComponent implements OnInit, AfterViewInit {
  #injector = inject(Injector)
  #flxWrapperStyle = inject(FlxWrapperStyleDirective)

  templateConfig = input.required<MarkdownTemplateConfig>()

  displayOptions = computed(() => this.templateConfig().displayOptions)
  flowxProps = computed(() => this.displayOptions().flowxProps)
  style = computed(() => this.displayOptions().style)

  // expressions
  isHidden: Signal<boolean>
  // dynamic props
  text: Signal<string>

  ariaHidden: Signal<boolean>
  ariaLabel: Signal<string | null>

  ngOnInit(): void {
    runInInjectionContext(this.#injector, () => {
      const { text, hide } = this.flowxProps()
      this.isHidden = getBoolExpressionSignal(hide, this.templateConfig(), { logType: 'hide' })
      this.ariaHidden = computed(() => {
        const accessibility = this.flowxProps().accessibility
        return accessibility && 'decorative' in accessibility ? accessibility.decorative : false
      })
      this.ariaLabel = computed(() => {
        const accessibility = this.flowxProps().accessibility
        return accessibility && 'label' in accessibility ? accessibility.label : null
      })
      this.text = getDynamicPropSignal(text, this.templateConfig())
    })
  }

  ngAfterViewInit(): void {
    runInInjectionContext(this.#injector, () => {
      effect(() => {
        this.#flxWrapperStyle.toggleDisplay(this.isHidden())
      })
    })
  }
}
